import { render, staticRenderFns } from "./OcrImportTouristDialog.vue?vue&type=template&id=5e541b3e&scoped=true&"
import script from "./OcrImportTouristDialog.vue?vue&type=script&lang=js&"
export * from "./OcrImportTouristDialog.vue?vue&type=script&lang=js&"
import style0 from "./OcrImportTouristDialog.vue?vue&type=style&index=0&id=5e541b3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e541b3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e541b3e')) {
      api.createRecord('5e541b3e', component.options)
    } else {
      api.reload('5e541b3e', component.options)
    }
    module.hot.accept("./OcrImportTouristDialog.vue?vue&type=template&id=5e541b3e&scoped=true&", function () {
      api.rerender('5e541b3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/OcrImportTouristDialog.vue"
export default component.exports